import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { motion } from 'motion/react';
import PageNavbar from './PageNavbar';
import Footer from './Footer';
import ScrollReveal from './ScrollReveal';
import { getRevealProps, staggerContainer, staggerItem, defaultViewport } from '../motion/scrollMotion';
import './ContentPages.css';

const ArticleListPage = ({ badge, title, accentWord, desc, sectionTag, sectionTitle, sectionDesc, posts, basePath }) => (
  <div className="content-page">
    <PageNavbar />

    <section className="content-hero">
      <div className="content-hero-background" />
      <div className="content-hero-stars" />
      <ScrollReveal className="content-hero-inner" animateOnMount variant="fadeUp">
        <span className="content-badge">{badge}</span>
        <h1 className="content-hero-title">
          {title} <span className="content-accent">{accentWord}</span>
        </h1>
        <p className="content-hero-desc">{desc}</p>
      </ScrollReveal>
    </section>

    <section className="content-section alt">
      <div className="content-container">
        <motion.div className="content-section-header" {...getRevealProps('fadeUp')}>
          <span className="content-section-tag">{sectionTag}</span>
          <h2 className="content-section-title">{sectionTitle}</h2>
          <p className="content-section-subtitle">{sectionDesc}</p>
        </motion.div>

        <motion.div
          className="content-grid"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={defaultViewport}
        >
          {posts.map((post) => (
            <motion.article key={post.slug} className="content-card" variants={staggerItem}>
              <div className="content-meta">{post.tag} · {post.date}</div>
              <h3 className="content-card-title">{post.title}</h3>
              <p className="content-card-desc">{post.excerpt}</p>
              <Link to={`${basePath}/${post.slug}`} className="content-card-link blog-read-btn">
                Read More <FaArrowRight />
              </Link>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>

    <Footer />
  </div>
);

export default ArticleListPage;
